/* KASSANDRA newsletter popup. Preview: ?kc_popup=1 or ?kc_popup=success */
(() => {
  const root = document.querySelector('[data-kc-pop]');
  if (!root || root.dataset.kcReady) return;
  root.dataset.kcReady = '1';

  const KEY_DISMISS = 'kc_popup_dismissed_at';
  const KEY_SUB = 'kc_popup_subscribed';
  const KEY_FIRST = 'kc_popup_first_seen';
  const SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000;
  const store = (s) => ({
    get: (k) => { try { return window[s].getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { window[s].setItem(k, v); } catch (e) { /* storage unavailable */ } }
  });
  const ls = store('localStorage');
  const ss = store('sessionStorage');

  const params = new URLSearchParams(window.location.search);
  const force = params.get('kc_popup');
  const dialog = root.querySelector('[data-kc-pop-dialog]');
  const form = root.querySelector('#kc-popup-form');
  const input = root.querySelector('#kc-pop-email');
  const errorEl = root.querySelector('#kc-pop-error');
  const submitBtn = root.querySelector('[data-kc-pop-submit]');
  const copyBtn = root.querySelector('[data-kc-pop-copy]');
  const copyLabel = root.querySelector('[data-kc-copy-label]');
  const copyStatus = root.querySelector('[data-kc-copy-status]');
  const views = {
    form: root.querySelector('[data-kc-view="form"]'),
    success: root.querySelector('[data-kc-view="success"]')
  };
  if (!dialog || !form || !input) return;
  const img = root.querySelector('.kc-pop__img');
  // Start loading the photo only for visitors who will see the popup.
  const warm = () => { if (img && img.loading === 'lazy') img.loading = 'eager'; };
  const imgReady = (fn) => {
    if (!img || (img.complete && img.naturalWidth)) { fn(); return; }
    let done = false;
    const go = () => { if (!done) { done = true; fn(); } };
    img.addEventListener('load', go, { once: true });
    img.addEventListener('error', go, { once: true });
    window.setTimeout(go, 1500);
  };
  form.setAttribute('novalidate', '');

  const MSG = {
    empty: 'Inserisci il tuo indirizzo email.',
    invalid: 'Inserisci un indirizzo email valido, ad esempio nome@esempio.it.',
    taken: 'Questa email è già iscritta alla nostra newsletter.',
    generic: 'Non è stato possibile completare l\u2019iscrizione. Riprova tra qualche istante.'
  };

  const path = window.location.pathname;
  const excludedPath = /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:cart|checkout|checkouts|account|policies)(?:\/|$)/i.test(path);
  const fromThisForm = window.location.hash === '#kc-popup-form';
  const postedOk = fromThisForm && (params.get('customer_posted') === 'true' || !!root.querySelector('[data-kc-posted]'));
  const serverErrors = fromThisForm ? root.querySelector('[data-kc-server-errors]') : null;

  let isOpen = false;
  let lastFocus = null;
  let timer = 0;
  let pendingSince = 0;
  let consentGoneAt = 0;
  let consentSeen = false;

  const visible = (el) => {
    if (!el || root.contains(el)) return false;
    const s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  };
  const consentUiVisible = () => Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog')).some(visible);
  const consentPending = () => {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function' || !cp.shouldShowBanner()) return false;
      const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return !!c && Object.values(c).some((v) => v === '');
    } catch (e) { return false; }
  };
  const otherOverlayOpen = () => Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [data-k-atp-navigation][data-open="true"]')).some(visible);
  const typingElsewhere = () => {
    const a = document.activeElement;
    return !!a && !root.contains(a) && a.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]');
  };

  const eligible = () => {
    if (excludedPath) return false;
    if (ls.get(KEY_SUB) === '1') return false;
    const d = Number(ls.get(KEY_DISMISS)) || 0;
    return !(d && Date.now() - d < SUPPRESS_MS);
  };

  const focusables = () => Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter((el) => el.getClientRects().length > 0 && !el.closest('[hidden]'));

  const setView = (name) => {
    Object.entries(views).forEach(([k, el]) => { if (el) el.hidden = k !== name; });
    dialog.setAttribute('aria-labelledby', name === 'success' ? 'kc-pop-title-success' : 'kc-pop-title');
    if (name === 'success') dialog.removeAttribute('aria-describedby');
    else dialog.setAttribute('aria-describedby', 'kc-pop-desc');
  };

  const open = (view) => {
    if (isOpen) { setView(view); return; }
    isOpen = true;
    setView(view);
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('kc-pop-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    const target = view === 'success' ? root.querySelector('#kc-pop-title-success') : dialog;
    window.requestAnimationFrame(() => target && target.focus({ preventScroll: true }));
    document.addEventListener('keydown', onKey, true);
  };

  const close = () => {
    if (!isOpen) return;
    isOpen = false;
    if (ls.get(KEY_SUB) !== '1') ls.set(KEY_DISMISS, String(Date.now()));
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.classList.remove('kc-pop-lock');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(() => { root.hidden = true; }, reduce ? 0 : 260);
    if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  };

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) { e.preventDefault(); dialog.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    const a = document.activeElement;
    if (e.shiftKey && (a === first || a === dialog || !dialog.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !dialog.contains(a))) { e.preventDefault(); first.focus(); }
  }

  // Wait for the Shopify privacy banner (and any other overlay) before opening.
  const whenClear = (fn, grace) => {
    window.clearTimeout(timer);
    const check = () => {
      const now = Date.now();
      if (consentUiVisible()) { consentSeen = true; consentGoneAt = 0; timer = window.setTimeout(check, 700); return; }
      if (!consentSeen && consentPending()) {
        if (!pendingSince) pendingSince = now;
        if (now - pendingSince < 4000) { timer = window.setTimeout(check, 500); return; }
      }
      if (consentSeen) {
        if (!consentGoneAt) consentGoneAt = now;
        if (now - consentGoneAt < grace) { timer = window.setTimeout(check, 400); return; }
      }
      if (otherOverlayOpen() || typingElsewhere() || document.hidden) { timer = window.setTimeout(check, 1500); return; }
      imgReady(fn);
    };
    warm();
    check();
  };

  const showError = (msg) => {
    errorEl.textContent = msg;
    input.setAttribute('aria-invalid', 'true');
  };
  const clearError = () => {
    errorEl.textContent = '';
    input.removeAttribute('aria-invalid');
  };
  const mapServerErrors = (node) => {
    const parts = Array.from(node.querySelectorAll('[data-field]'));
    const text = (parts.length ? parts.map((p) => p.getAttribute('data-field') + ' ' + p.textContent) : [node.textContent]).join(' ').toLowerCase();
    if (/taken|già|gia'|already|exist|utilizzat|registrat/.test(text)) return MSG.taken;
    if (/email|e-mail/.test(text) || /invalid|non è valid|non valid|formato/.test(text)) return MSG.invalid;
    return MSG.generic;
  };
  const busy = (on) => {
    if (submitBtn) submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  // Native post: Shopify's storefront bot protection (hCaptcha) binds to this
  // customer form and needs the real submit event; a fetch() post is rejected
  // with 400. After the redirect (?customer_posted=true#kc-popup-form) the popup
  // reopens in the success state.
  form.addEventListener('submit', (e) => {
    clearError();
    const email = input.value.trim();
    input.value = email;
    if (!email) { e.preventDefault(); showError(MSG.empty); input.focus(); return; }
    if (!input.checkValidity() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { e.preventDefault(); showError(MSG.invalid); input.focus(); return; }
    busy(true);
    ss.set('kc_popup_submitting', String(Date.now()));
    window.setTimeout(() => busy(false), 8000);
  });
  input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true') clearError(); });

  root.querySelectorAll('[data-kc-pop-dismiss]').forEach((el) => el.addEventListener('click', close));

  if (copyBtn) {
    let resetT = 0;
    copyBtn.addEventListener('click', async () => {
      const code = copyBtn.getAttribute('data-code') || 'KASSANDRA10';
      let ok = false;
      try { await navigator.clipboard.writeText(code); ok = true; } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        dialog.appendChild(ta); ta.select();
        try { ok = document.execCommand('copy'); } catch (e2) { ok = false; }
        ta.remove();
      }
      copyLabel.textContent = ok ? 'Codice copiato' : 'Copia codice';
      copyStatus.textContent = ok ? 'Codice ' + code + ' copiato negli appunti.' : 'Copia non riuscita: seleziona il codice e copialo manualmente.';
      window.clearTimeout(resetT);
      resetT = window.setTimeout(() => { copyLabel.textContent = 'Copia codice'; }, 2600);
    });
  }

  window.addEventListener('pagehide', () => window.clearTimeout(timer));

  // Returning from a normal (non-fetch) post of this form.
  if (postedOk) { ls.set(KEY_SUB, '1'); whenClear(() => open('success'), 600); return; }
  if (serverErrors) { whenClear(() => { open('form'); showError(mapServerErrors(serverErrors)); }, 600); return; }

  // Preview overrides.
  if (force === 'success') { window.setTimeout(() => whenClear(() => open('success'), 800), 600); return; }
  if (force === '1' || force === 'true') { window.setTimeout(() => whenClear(() => open('form'), 800), 600); return; }

  if (!eligible()) return;
  const delayMs = 15 * 1000; // 15 s after this page opens (Livio, 8 Oct 2026); theme 'delay_seconds' setting no longer used
  let first = Number(ss.get(KEY_FIRST)) || 0;
  if (!first) { first = Math.round((window.performance && performance.timeOrigin) || Date.now()); ss.set(KEY_FIRST, String(first)); }
  const wait = Math.max(0, delayMs - (Date.now() - Math.round((window.performance && performance.timeOrigin) || Date.now())));
  window.setTimeout(warm, Math.max(0, wait - 2500));
  timer = window.setTimeout(() => whenClear(() => { if (eligible()) open('form'); }, 2500), wait);
})();
